import { render } from "./EventsHeader.vue?vue&type=template&id=192539c3&scoped=true"
import script from "./EventsHeader.vue?vue&type=script&lang=js"
export * from "./EventsHeader.vue?vue&type=script&lang=js"

import "./EventsHeader.vue?vue&type=style&index=0&id=192539c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-192539c3"]])

export default __exports__